var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "distributor-item" }, [
    _c(
      "div",
      { staticClass: "distributor-item__inner" },
      [
        _vm.distributorItem.ImageHtml.Src ||
        _vm.distributorItem.ImageHtml.HasCrop
          ? _c("ResponsiveImage", {
              attrs: {
                imageModel: _vm.distributorItem.ImageHtml,
                wrapClass: "distributor-item__image"
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "distributor-item__info" }, [
          _c("div", { staticClass: "distributor-item__row" }, [
            _c("p", { staticClass: "distributor-item__headline" }, [
              _vm._v(_vm._s(_vm.distributorItem.Name))
            ])
          ]),
          _vm._v(" "),
          _vm.distributorItem.PoBox ||
          _vm.distributorItem.Phone ||
          _vm.distributorItem.Mobile ||
          _vm.distributorItem.Website ||
          _vm.distributorItem.Territory
            ? _c("div", { staticClass: "distributor-item__row" }, [
                _vm.distributorItem.PoBox
                  ? _c("p", { staticClass: "distributor-item__text" }, [
                      _vm._v(_vm._s(_vm.distributorItem.PoBox))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.distributorItem.Phone
                  ? _c("p", { staticClass: "distributor-item__text" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.dictionaries.DistributorPhone) +
                          " "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "distributor-item__link",
                          attrs: { href: "tel:" + _vm.distributorItem.Phone }
                        },
                        [_vm._v(_vm._s(_vm.distributorItem.Phone))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.distributorItem.Mobile
                  ? _c("p", { staticClass: "distributor-item__text" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.dictionaries.DistributorMobile) +
                          " "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "distributor-item__link",
                          attrs: { href: "tel:" + _vm.distributorItem.Mobile }
                        },
                        [_vm._v(_vm._s(_vm.distributorItem.Mobile))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.distributorItem.HasWebsite
                  ? _c("p", { staticClass: "distributor-item__text" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.dictionaries.DistributorWebsite) +
                          " "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "distributor-item__link",
                          attrs: {
                            href: _vm.distributorItem.WebsiteUrl,
                            target: _vm.distributorItem.WebsiteTarget
                          }
                        },
                        [_vm._v(_vm._s(_vm.distributorItem.WebsiteName))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.distributorItem.Territory
                  ? _c("p", { staticClass: "distributor-item__text" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.dictionaries.DistributorTerritory) +
                          " " +
                          _vm._s(_vm.distributorItem.Territory) +
                          "\n                "
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e13ce44", { render: render, staticRenderFns: staticRenderFns })
  }
}